
import { Component, Vue } from 'vue-property-decorator';
import AppLogo from '@/app/components/common/AppLogo.vue';
import ClientResposiveNav from '@/app/components/nav/ClientResponsiveNav.vue';
import AdminResposiveNav from '@/app/components/nav/AdminResponsiveNav.vue';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    AppLogo,
    ClientResposiveNav,
    AdminResposiveNav,
  },
})
export default class SideNav extends Vue {
  get authStore() {
    return useAuthStore();
  }

  get isClientUser() {
    return this.authStore.isClientUser;
  }
}
